import { useNavigate } from "react-router-dom";

const TermsConditions = () => {
    const navigate = useNavigate();

    return (
        <><div className="main_title">
            <h1>Terms and Conditions</h1>
            <p>
                <button onClick={() => navigate("/dashboard")}>Dashboard</button> -Terms and Conditions
            </p>
        </div><div className="cards terms">
                <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Molestiae natus, dolor eaque tempora repudiandae quod dolore dolores quis nihil numquam tempore ipsa in nobis beatae libero impedit. Vel culpa temporibus commodi recusandae. Consectetur voluptatum inventore aspernatur sint, veniam sed ipsa impedit quae perspiciatis dolores. Suscipit voluptatum possimus ducimus voluptate laborum praesentium nostrum! Voluptatem consequuntur ullam, voluptatum quis esse quia iure minima a placeat consequatur, tempore praesentium vel veniam consectetur? Itaque tenetur totam aspernatur quasi qui magni quia minus quam vitae quas deserunt ab, laboriosam expedita molestias facere provident impedit at voluptatum omnis. Accusantium quis dolore est vero doloribus unde temporibus!</p>
            </div></>
    );
}
export default TermsConditions;